<template>
<div>
  <div v-if="weekends === null">
    <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10"
                         md-mode="indeterminate"></md-progress-spinner>
  </div>
  <div v-else>
    <md-card v-if="futureWeekends && futureWeekends.length > 0">
      <md-card-header>
        <div class="md-title">Future Weekends</div>
      </md-card-header>

      <md-card-content>
        <md-list class="md-triple-line">

          <md-list-item v-for="object in futureWeekends" :key="object.versionedId.id">
            <div class="md-list-item-text">
              <span>{{object.name}}</span>
              <span>{{lookupCourseName(object.courseIds)}}</span>
              <p>{{object.start}}</p>
            </div>
            <md-button class="md-icon-button md-dense md-primary editButton"
                       :to="currentCity.abbreviation + '/weekend/' + object.versionedId.id">
              <md-icon>today</md-icon>
            </md-button>
            <md-button class="md-icon-button md-dense md-primary editButton"
                       :to="currentCity.abbreviation + '/weekendReports/' + object.versionedId.id">
              <md-icon>link</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
      </md-card-content>
    </md-card>
    <br/>

    <br/>

    <md-card v-if="pastWeekends && pastWeekends.length > 0">
      <md-card-header>
        <div class="md-title">Past Weekends</div>
      </md-card-header>

      <md-card-content>
        <md-list class="md-triple-line">

          <md-list-item v-for="object in pastWeekends" :key="object.versionedId.id">
            <div class="md-list-item-text">
              <span>{{object.name}}</span>
              <span>{{lookupCourseName(object.courseIds)}}</span>
              <p>{{object.start}}</p>
            </div>
            <md-button class="md-icon-button md-dense md-primary editButton"
                       :to="currentCity.abbreviation + '/weekend/' + object.versionedId.id">
              <md-icon>today</md-icon>
            </md-button>
            <md-button class="md-icon-button md-dense md-primary editButton"
                       :to="currentCity.abbreviation + '/weekendReports/' + object.versionedId.id">
              <md-icon>link</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
      </md-card-content>
    </md-card>
    <br/>

    <md-empty-state v-if="(futureWeekends.length === 0) && (pastWeekends && pastWeekends.length === 0)"
                    md-icon="folder_special"
                    md-label="Create your first weekend"
                    md-description="There aren't any weekends yet.">
      <md-button class="md-primary md-raised" :to="currentCity.abbreviation + '/new'">Create weekend</md-button>
    </md-empty-state>
  </div>
</div>
</template>

<script>
  import moment from 'moment'

  var DISPLAY_LIMIT = 5;

  export default {
    name: "CityMainDefault",
    computed: {
      currentCity() {
        return this.$store.state.currentCity
      },
      weekends() {
        if (this.$store.state.currentCityDetails && this.$store.state.currentCityDetails.weekends) {
          return this.$store.state.currentCityDetails.weekends;
        } else {
          return null;
        }
      },
      pastWeekends() {
        if (this.weekends) {
          var weekends = [];
          this.weekends.forEach(weekend => {
            if (moment(weekend.end).isBefore(moment())) {
              weekends.push(weekend);
            }
          });
          return weekends.slice(0, DISPLAY_LIMIT);
        } else {
          return null;
        }
      },
      futureWeekends() {
        if (this.weekends) {
          var weekends = [];
          this.weekends.forEach(weekend => {
            if (!moment(weekend.end).isBefore(moment()))
              weekends.unshift(weekend);
          });
          return weekends.slice(0, DISPLAY_LIMIT);
        } else {
          return null;
        }
      }
    },
    methods: {
      lookupCourseName(ids) {
        if (!ids || !this.$store.state.currentCityDetails)
          return '';

        var courseNames = [];
        this.$store.state.currentCityDetails.courses.forEach(course => {
          ids.forEach(id => {
            if (course.versionedId.id === id.id)
              courseNames.push(course.name);
          });
        });
        return courseNames.join(", ");
      }
    }
  }
</script>

<style scoped>
  .md-card {
    width: 426px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/city/Default.vue